module.exports = __webpack_public_path__ + "UK_Tax_Strategy.pdf";